import { useMemo } from "react";
import { useMyFollowUps } from "@/hooks/use-follow-ups";
import { DEFAULT_SALES_MEETING, useSalesMeetingConfig, type SalesMeetingConfig } from "@/hooks/use-crm-config";
import { weekProgress, type WeekProgress } from "@/lib/follow-up-calc";

export interface UseWeekProgress extends WeekProgress {
  salesMeeting: SalesMeetingConfig;
  isLoading: boolean;
}

/**
 * «Din uke» for aktiv bruker. Regnes av de samme oppfølgingene som køen
 * (useMyFollowUps, nøkkel ["follow-ups", ownerId, ...]), så ett nettverkskall
 * og én invalidering dekker begge.
 */
export function useWeekProgress(): UseWeekProgress {
  const { data, isLoading } = useMyFollowUps();
  const { data: salesMeeting } = useSalesMeetingConfig();
  const progress = useMemo(() => weekProgress(data ?? [], new Date()), [data]);
  return { ...progress, salesMeeting: salesMeeting ?? DEFAULT_SALES_MEETING, isLoading };
}
